import React from 'react'
import { Button, useModal, theme } from '@fortressiq/fiq-ds'
import IpAddressListForm from './IpAddressListForm'

const AddIpAddress = ({ handleReFetch, whitelistStatus, setSortBy }) => {
  const createModalId = 'create-ipaddress-list-form'
  const modalConfig = {
    footer: false,
    style: { height: 'auto', width: '400px' },
    config: { interactWithKeyboard: false, destroyOnClose: true },
    headerStyle: { background: theme.white },
  }
  const { addModal, removeModal } = useModal()

  /* istanbul ignore next */
  const openModal = () => {
    addModal({
      children: (
        <IpAddressListForm
          handleReFetch={handleReFetch}
          removeModal={() => removeModal(createModalId)}
          setSortBy={setSortBy}
        />
      ),
      header: 'Add IP Address',
      id: createModalId,
      ...modalConfig,
    })
  }

  return (
    <Button
      type='secondary'
      key={createModalId}
      disabled={!whitelistStatus}
      onClick={() => openModal()}
      className='addIpAddress'
    >
      Add IP Address
    </Button>
  )
}

export default AddIpAddress
